<booking-form-general
  *ngIf="!generalFormSubmitted && booking$ | async"
  (onSubmit)="onSubmit($event)"
  [booking]="booking$ | async"
  (onShowConflictsBookings)="onShowConflicts($event)"
>
</booking-form-general>
